import React, { useRef } from 'react';
import { TextField } from '@mui/material';

const NumberField = ({
    value,
    onTradeoffValueChange,
    id,
    min,
    max,
    isRange,
    disabled = false,
}: {
    value: number | number[],
    onTradeoffValueChange: (value: any, id: string) => void;
    id: string;
    isRange: boolean;
    disabled?: boolean;
    min?: number;
    max?: number;
}) => {
    const rangeMin = useRef<HTMLInputElement | null>(null);
    const rangeMax = useRef<HTMLInputElement | null>(null);

    const valueMinMax = (val: number) => {
        if (min !== undefined && val < min) return min;
        if (max !== undefined && val > max) return max;
        return val;
    };

    const getRangeValue = (): number[] => {
        const rawMin = rangeMin.current ? +(rangeMin.current.value) : 0;
        const rawMax = rangeMax.current ? +(rangeMax.current.value) : 0;

        const clampedMin = valueMinMax(rawMin);
        const clampedMax = valueMinMax(rawMax);

        return [clampedMin, clampedMax].sort((a, b) => a - b);
    };

    const onNumberChange = () => {
        onTradeoffValueChange(getRangeValue(), id);
    };

    return (
        <div>
            {isRange ? (
                <>
                    <TextField
                        style={{ marginRight: 8, marginBottom: 12 }}
                        label="Min"
                        inputRef={rangeMin}
                        type="number"
                        defaultValue={(value as number[])[0]}
                        onBlur={onNumberChange}
                        disabled={disabled}
                        InputProps={{ inputProps: { min, max } }}
                    />
                    <TextField
                        label="Max"
                        inputRef={rangeMax}
                        type="number"
                        defaultValue={(value as number[])[1]}
                        onBlur={onNumberChange}
                        disabled={disabled}
                        InputProps={{ inputProps: { min, max } }}
                    />
                </>
            ) : (
                <TextField
                    type="number"
                    defaultValue={valueMinMax(value as number)}
                    onBlur={(e) =>
                        onTradeoffValueChange(valueMinMax(+e.target.value), id)
                    }
                    InputProps={{ inputProps: { min, max } }}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default NumberField;
